import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UserSendTestEmailPayload } from 'api/actions/user-send-test-email/user-send-test-email-payload';
import { UserSendTestEmailPathParameters } from 'api/actions/user-send-test-email/user-send-test-email-path-parameters';
import { UserSendTestEmailResponse } from 'api/actions/user-send-test-email/user-send-test-email-response';

type UserSendTestEmailQueryParameters = Record<string, any>;

/**
 * The path of the UserSendTestEmail action.
 */
export const userSendTestEmailActionPath = new SweetPath<keyof UserSendTestEmailPathParameters>(
  '/api/user/send-test-email',
  { path: '{param}' }
);

/**
 * Creates a contextualized UserSendTestEmail actions.
 */
export default function createUserSendTestEmailAction(axios: AxiosInstance) {
  return function userSendTestEmailAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: UserSendTestEmailQueryParameters;
    payload: UserSendTestEmailPayload;
  }) {
    const path = userSendTestEmailActionPath.original;

    return axios.request<UserSendTestEmailResponse, UserSendTestEmailResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
